import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { getCustomComponentProperty } from '@savgroup-front-common/core/helpers';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import {
  SUPPORTED_COMPONENTS,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

export const $HomeContentWrapper = styled.div`
  background-color: white;
  border-radius: ${({ theme }) =>
    getCustomComponentProperty({
      theme,
      componentName: SUPPORTED_COMPONENTS.CARD,
      property: SUPPORTED_PROPERTIES.BORDER_RADIUS,
      fallback: theme.borders.radius,
    })};
  min-height: 70vh;
  padding: ${spacing('xl')} ${spacing(12)};
  gap: ${spacing('xl')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${media.maxWidth.xs} {
    padding: ${spacing(3.5)};
  }

  & [class*='TabContainer'] {
    padding: 0;
  }

  & [class*='RouteTabLink'] {
    padding: ${spacing(3.5)};
    padding-top: 0;
  }

  & [class*='TabViewList'] {
    width: fit-content;
    padding: 0;

    & a:-webkit-any-link {
      text-decoration: none;
    }

    & [class*='RouteTabLink'] {
      & [class*='MessageWithIcon'] {
        flex-direction: column;
        gap: ${spacing('xs')};

        & > svg {
          width: ${spacing('xxl')};
          height: ${spacing('xxl')};
          margin: 0;
          fill: none;
        }
      }
      &:hover,
      &:focus {
        & [class*='MessageWithIcon'] > svg path[stroke] {
          stroke: ${({ theme }) => theme.colors.primary} !important;
        }
        & [class*='MessageWithIcon'] > svg path[fill] {
          fill: ${({ theme }) => theme.colors.primary} !important;
        }
      }
      &:focus {
        & [class*='MessageWithIcon'] > span {
          color: ${({ theme }) => theme.colors.primary};
        }
      }
    }
  }

  & [class*='TabViewNav'] {
    width: fit-content;
    padding: 0;
    margin: auto;
  }
`;

export const $HomeProductsListWrapper = styled.div`
  gap: ${spacing(3.5)};
  display: flex;
  flex-direction: column;
  align-items: center;

  & [class*='MonoProductInfostyles__Card'],
  &
    [class*='MonoProductInfostyles__Card']
    ~ [class*='MonoProductInfostyles__Card'] {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
